'use client';
import { useEffect } from 'react';
import { toast } from 'sonner';
import { useAuth } from '@/contexts/AuthContext';

const IDLE_MS = 30 * 60 * 1000;
const ACTIVITY_EVENTS = [
  'mousemove',
  'keydown',
  'click',
  'scroll',
  'touchstart',
  'visibilitychange',
] as const;

/** Signs a forgotten tab out after 30 minutes without any activity. */
export default function IdleGuard() {
  const { user, signOut } = useAuth();

  useEffect(() => {
    if (!user) return;
    let timer: number | undefined;
    const arm = () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(async () => {
        toast.info('You were signed out after 30 minutes of inactivity.');
        await signOut();
      }, IDLE_MS);
    };
    ACTIVITY_EVENTS.forEach((name) => window.addEventListener(name, arm, { passive: true }));
    arm();
    return () => {
      window.clearTimeout(timer);
      ACTIVITY_EVENTS.forEach((name) => window.removeEventListener(name, arm));
    };
  }, [user, signOut]);

  return null;
}
